/*
  block-tracking.js — 施策枠の「表示」「クリック」を汎用に計測する（2026-08 施策計測の穴埋め）

  対象: data-ref-block="<枠名>" を持つ全要素（attribution-ref.js が経由売上に使う目印と同じ）
    → 個別セクションに手を入れず、TOPお気に入り作品/カート内クロスセル/セットBOX面/
      検索受け皿/PDPクロスセル/お気に入りページ の全枠を自動でカバーする

  送るイベント（theme.liquid のブリッジが GA4 に転送）:
    block_view  { block }                       … 枠が画面内に入った時（枠ごとにページ内1回）
    block_click { block, to_product_url }       … 枠内の商品リンククリック
    deadline_badge_click { days_left, to_product_url } … 締切バッジ付き商品カードのクリック

  補足:
    - block_view は「商品が描画済み」の枠だけ数える（JS棚は描画前は空なので、子要素が出るまで待つ）
    - 既存の個別イベント（wishlist_shelf_click 等）はそのまま残す（互換）。
      block_click は横断比較用（枠名で統一集計できる）
    - 計測が失敗しても導線を止めない（全部 try/catch）
*/
(function () {
  function push(obj) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj);
    } catch (e) {}
  }

  // ---- 表示計測 ------------------------------------------------------------
  var viewed = {};
  var io = null;

  function hasProducts(el) {
    return !!el.querySelector('a[href*="/products/"]');
  }

  function markViewed(el) {
    var name = el.getAttribute('data-ref-block');
    if (!name || viewed[name]) return;
    viewed[name] = true;
    push({ event: 'block_view', block: name });
  }

  function observe(el) {
    if (!el || el.__btObserved) return;
    el.__btObserved = true;
    if (!io) {
      // 半分見えたら「表示」とみなす。画面外で描画された枠を数えない
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          if (!hasProducts(el)) return; // まだ描画されていない
          io.unobserve(el);
          markViewed(el);
        });
      }, { threshold: 0.5 });
    }
    io.observe(el);
  }

  function scan() {
    try {
      var blocks = document.querySelectorAll('[data-ref-block]');
      for (var i = 0; i < blocks.length; i++) {
        var el = blocks[i];
        var name = el.getAttribute('data-ref-block');
        if (!name || viewed[name]) continue;
        observe(el);
        // 描画完了後に画面内にいるケース: IntersectionObserver は再評価しないので、
        // 子要素が増えたら observe し直す
        if (el.__btObserved && hasProducts(el) && io) {
          io.unobserve(el);
          io.observe(el);
        }
      }
    } catch (e) {}
  }

  if (typeof IntersectionObserver === 'function') {
    scan();
    // JS棚は後から描画されるので DOM の変化を見て再スキャン（負荷を抑えるため間引き）
    var timer = null;
    try {
      new MutationObserver(function () {
        if (timer) return;
        timer = setTimeout(function () { timer = null; scan(); }, 300);
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  // ---- クリック計測 ----------------------------------------------------------
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('a[href*="/products/"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';

      // 枠内クリック
      var block = a.closest('[data-ref-block]');
      if (block) {
        push({ event: 'block_click', block: block.getAttribute('data-ref-block'), to_product_url: href });
      }

      // 締切バッジ付き商品カードのクリック（施策②）
      var card = a.closest('.product-item');
      if (card) {
        var badge = card.querySelector('.sdl--deadline');
        if (badge) {
          var days = parseInt(badge.getAttribute('data-days-left'), 10);
          if (isNaN(days)) {
            days = -1;
            if (badge.classList.contains('sdl--today')) {
              days = 0;
            } else {
              var m = (badge.textContent || '').match(/あと(\d+)日/);
              if (m) days = parseInt(m[1], 10);
            }
          }
          push({ event: 'deadline_badge_click', days_left: days, to_product_url: href });
        }
      }
    } catch (err) {}
  }, true);
})();
